import React from "react";
import { Dropdown } from "react-bootstrap";
import { NavLink } from 'react-router-dom';

const CpntHeaderFONosServicesDropDownOptions: React.FC = () => {

  return (
    <>
        <Dropdown.Item as={NavLink} to="/gestion-catalogue" rel="prerender">
            <i className="bi bi-book pe-2" />Gestion de votre catalogue
        </Dropdown.Item> 
        <Dropdown.Item as={NavLink} to="/alerte-poche" rel="prerender">
            <i className="bi bi-bell pe-2" />Alerte Poche
        </Dropdown.Item>
        <Dropdown.Item as={NavLink} to="/data-control" rel="prerender">
            <i className="bi bi-hourglass-split pe-2" />Electre Data Control
        </Dropdown.Item>
        <Dropdown.Item as={NavLink} to="/data-expert" rel="prerender">
            <i className="bi bi-eyeglasses pe-2" />Electre Data Expert
        </Dropdown.Item>
        <Dropdown.Item as={NavLink} to="/achat-fichier" rel="prerender">
            <i className="bi bi-file-earmark-zip pe-2" />Achat de fichiers
        </Dropdown.Item>
        <Dropdown.Item as={NavLink} to="/actualisation-referencement" rel="prerender">
            <i className="bi bi-arrow-clockwise pe-2" />Actualisation du référencement
        </Dropdown.Item>
    </>
  );
};

export default CpntHeaderFONosServicesDropDownOptions;
